// extracted by mini-css-extract-plugin
export default {"wrap":"zq-z","logoContainer":"Aq-z","brandImg":"Bq-z","logoImg":"Cq-z","logoButton":"Dq-z"};